import { MapUiTheme } from '../../common';

export const ratingTheme = {
  defaultStyles: {
    color: 'inherit',
  },
  clickable: {
    cursor: 'pointer',
  },
  xs: {
    fontSize: (theme: MapUiTheme) => theme.fontSize.sm,
    marginRight: '0',
  },
  sm: {
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
    marginRight: (theme: MapUiTheme) => theme.spacing[1],
  },
  md: {
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
    marginRight: (theme: MapUiTheme) => theme.spacing[1],
  },
  lg: {
    fontSize: (theme: MapUiTheme) => theme.fontSize['3xl'],
    marginRight: (theme: MapUiTheme) => theme.spacing[2],
  },
  xl: {
    fontSize: (theme: MapUiTheme) => theme.fontSize['5xl'],
    marginRight: (theme: MapUiTheme) => theme.spacing[2],
  },
};
